<template>
  <main class="view-product-details d-flex flex-column pb-5" itemscope itemtype="http://schema.org/Product">
    <article class="col-lg-9 col-md-10 col-sm-11 col-xxs-12 mx-auto p-0">
      <MusicSummary :product="Product" />
      <div class="d-flex flex-sm-row flex-xxs-column justify-content-between px-sm-0 px-xxs-3" />
      <ProductScreenshots v-if="Product.screenShots && Product.screenShots.length > 0" :product="Product" />
      <SimpleCollectionHost
        v-if="Product.collections && Product.collections.length > 0"
        :configurations="{id: Product.collections[0].id}"
        :title="$t('product.similarProducts', {products: this.globalResources.productTranslation.Plural})"
      />
      <ProductLicense :title="Product.name" />
    </article>
  </main>
</template>

<script>
import Vue from 'vue'
import MusicSummary from '@/components/MusicSummary.vue'
import ProductScreenshots from '@/components/ProductScreenshots.vue'
import SimpleCollectionHost from '@/components/SimpleCollectionHost.vue'
import ProductLicense from '@/components/ProductLicense.vue'

import { mapGetters, mapActions } from 'vuex'

export default Vue.extend({
  name: 'MusicDetail',
  components: {
    MusicSummary,
    ProductScreenshots,
    SimpleCollectionHost,
    ProductLicense
  },
  props: {
    product: Object
  },
  data () {
    return {
      productId: 0
    }
  }
})
</script>
